import './styles/product-view.scss';